export default __webpack_public_path__ + "static/media/33.ea8d6c20.jpeg";